import React from 'react';
import { ShieldCheck, Lock, RotateCcw, Clock } from 'lucide-react';
import { Button } from '../ui/Shared';
export function GuaranteeSection() {
  return <section id="garantia" className="py-24 bg-surface" data-id="element-184">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-185">
        <div className="scale-in bg-gradient-to-br from-secondary to-accent/5 border-2 border-accent/30 rounded-[20px] p-10 md:p-14 text-center relative overflow-hidden" data-id="element-186">
          <div className="w-28 h-28 bg-gradient-gold rounded-full flex flex-col items-center justify-center mx-auto mb-8 shadow-[0_8px_32px_rgba(232,160,32,0.3)]" data-id="element-187">
            <span className="font-playfair text-4xl font-black text-primary leading-none" data-id="element-188">
              7
            </span>
            <span className="text-[10px] font-extrabold text-primary tracking-widest uppercase mt-1" data-id="element-189">
              días de garantía
            </span>
          </div>

          <h2 className="font-playfair text-3xl font-black mb-4 text-text-light" data-id="element-190">
            "¿Cómo saber si me ayuda?"
            <br data-id="element-191" />
            <span className="text-accent" data-id="element-192">Pruébalo sin riesgo.</span>
          </h2>

          <p className="text-base text-text-muted leading-relaxed max-w-[580px] mx-auto mb-8" data-id="element-193">
            Sé que ya probaste remedios, medicamentos y consejos que no
            funcionaron. Sé que piensas <em data-id="element-194">"ojalá me ayude"</em>. Por eso
            tienes 7 días completos para aplicar el protocolo. Si sientes que no
            fue lo que esperabas, te devuelvo el dinero completo. Sin preguntas,
            sin procesos largos, sin drama. Punto.
            <br data-id="element-195" />
            <br data-id="element-196" />
            Ofrezco esta garantía porque más de 850 personas ya lo aplicaron — y
            porque la confianza se gana, no se exige.
          </p>

          <div className="flex justify-center gap-6 md:gap-8 flex-wrap mb-9" data-id="element-197">
            <div className="flex flex-col items-center gap-2" data-id="element-198">
              <ShieldCheck className="w-7 h-7 text-accent" data-id="element-199" />
              <span className="text-xs text-text-muted" data-id="element-200">100% Protegido</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-201">
              <Lock className="w-7 h-7 text-accent" data-id="element-202" />
              <span className="text-xs text-text-muted" data-id="element-203">Pago Seguro</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-204">
              <RotateCcw className="w-7 h-7 text-accent" data-id="element-205" />
              <span className="text-xs text-text-muted" data-id="element-206">
                Devolución Sin Preguntas
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-207">
              <Clock className="w-7 h-7 text-accent" data-id="element-208" />
              <span className="text-xs text-text-muted" data-id="element-209">7 Días de Plazo</span>
            </div>
          </div>

          <div className="flex justify-center" data-id="element-210">
            <Button href="#cta-final" data-id="element-211">
              <Lock className="w-5 h-5" data-id="element-212" />
              Acceder con garantía total
            </Button>
          </div>
        </div>
      </div>
    </section>;
}